import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations, contactInfo } from '../data/mock';
import { Phone, Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: t(translations.header).home },
    { path: '/about', label: t(translations.header).about },
    { path: '/courses', label: t(translations.header).courses },
    { path: '/why-us', label: t(translations.header).whyUs },
    { path: '/reviews', label: t(translations.header).reviews },
    { path: '/gallery', label: t(translations.header).gallery },
    { path: '/contact', label: t(translations.header).contact },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      {/* Top Bar */}
      <div className="bg-[#0B1F3F] text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center space-x-4">
            <a href={`tel:${contactInfo.phone}`} className="flex items-center hover:text-orange-400 transition-colors">
              <Phone className="h-4 w-4 mr-1" />
              <span className="hidden sm:inline">{contactInfo.phone}</span>
            </a>
            <span className="hidden md:inline">⭐ {contactInfo.rating} ({contactInfo.totalReviews} Reviews)</span>
          </div>
          <button
            onClick={toggleLanguage}
            className="flex items-center hover:text-orange-400 transition-colors"
          >
            <Globe className="h-4 w-4 mr-1" />
            <span>{language === 'en' ? 'తెలుగు' : 'English'}</span>
          </button>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-12 h-12 bg-[#FF6B35] rounded-full flex items-center justify-center text-white font-bold text-xl">
              T
            </div>
            <div>
              <h1 className="text-xl font-bold text-[#0B1F3F]">Tanuku Driving School</h1>
              <p className="text-xs text-gray-600">తణుకు డ్రైవింగ్ పాఠశాల</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-[#FF6B35] ${
                  isActive(item.path) ? 'text-[#FF6B35]' : 'text-gray-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              asChild
              className="bg-[#FF6B35] hover:bg-[#FF5722] text-white"
            >
              <a href={`tel:${contactInfo.phone}`}>
                <Phone className="h-4 w-4 mr-2" />
                {t(translations.hero).callBtn}
              </a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t pt-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium transition-colors hover:text-[#FF6B35] ${
                  isActive(item.path) ? 'text-[#FF6B35]' : 'text-gray-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Button
              asChild
              className="w-full mt-4 bg-[#FF6B35] hover:bg-[#FF5722] text-white"
            >
              <a href={`tel:${contactInfo.phone}`}>
                <Phone className="h-4 w-4 mr-2" />
                {t(translations.hero).callBtn}
              </a>
            </Button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
